import { Clock, RefreshCw, LogOut } from 'lucide-react';
import './SessionWarning.css';

interface SessionWarningProps {
  timeUntilTimeout: number;
  onExtendSession: () => void;
  onForceLogout: () => void;
}

export function SessionWarning({ 
  timeUntilTimeout, 
  onExtendSession, 
  onForceLogout 
}: SessionWarningProps) {
  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const isUrgent = timeUntilTimeout <= 60; // Less than 1 minute

  return (
    <div className={`session-warning ${isUrgent ? 'urgent' : ''}`}>
      <div className="session-warning-content">
        <div className="session-warning-icon">
          <Clock className="icon" />
        </div>
        
        <div className="session-warning-text">
          <h3>Session Timeout Warning</h3>
          <p>
            Your session will expire in{' '}
            <span className="time-remaining">{formatTime(timeUntilTimeout)}</span>
            {' '}due to inactivity.
          </p>
        </div>
        
        <div className="session-warning-actions">
          <button
            className="extend-button"
            onClick={onExtendSession}
            title="Extend session"
          >
            <RefreshCw className="icon" />
            Extend Session
          </button>
          
          <button
            className="logout-button"
            onClick={onForceLogout}
            title="Log out now"
          >
            <LogOut className="icon" />
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
}









